import Vue from "vue";

export default Vue.extend({
  data: () => ({
    requestPromises: {} as { [hash: string]: number }
  }),
  beforeDestroy() {
    if (!this.$_.isEmpty(this.requestPromises))
      this.$store.commit("api/cancelRequests", this.requestPromises);
  }
});
